module.exports = __webpack_public_path__ + "static/iphone-kid-3bf23e7559deecb0409f92f730e6ccd6.png";